import { LocalizationsStore } from '~/app-modules/core/stores/localizations.store';
import { TokensStore } from '~/app-modules/auth/stores/tokens.store';
import { UserStore } from '~/app-modules/user/stores/user.store';

// Плагин для инициализации хранилищ данных и IOC зависимостей,
// вызывается дважды на сервере и клиенте, для корректной гидратации
// на ssr необходимо учитывать передаваемые типы данных и исключать повторную загрузку

export default defineNuxtPlugin({
  name: 'initIOCDependencies',
  parallel: false,
  dependsOn: ['ioc'], //'vuetify'
  enforce: 'post', // pre|default|post
  async setup() {
    useIOC(TokensStore);
    useIOC(UserStore);
    useIOC(LocalizationsStore);
  },
});
